import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { DOMId } from '@editor/src/page/index/components/canvas/canvas-constants';
import creatEditableDivInBody from '@src/slide/application/service/accessibility-manager/core/utils';

/**
 * 通过在canvas中动态加载一个button，将焦点转移至canvas
 */
const changeFocusToCanvas = () => {
    let extraButton = document.getElementById(DOMId.EXTRA_BUTTON_FOR_IFRAME_FOCUS);
    if (!extraButton) {
        extraButton = creatEditableDivInBody();
        extraButton.setAttribute('id', DOMId.EXTRA_BUTTON_FOR_IFRAME_FOCUS);
        extraButton.setAttribute('aria-hidden', 'true');
        document.body.appendChild(extraButton);
    }
    extraButton.focus();
    extraButton.blur();
};
export default changeFocusToCanvas;

export function getSlideWidthDiff(uiDataService?: IUiDataService): number {
    if (!uiDataService) return 0;
    const singleNumberWidth = 5;
    const maxDigitNumber = 3;
    const { slideModelList, presentation } = uiDataService;
    const maxSlideIndex = slideModelList.length + presentation.firstSlideNum;

    return Math.max((maxSlideIndex.toString().length - maxDigitNumber), 0) * singleNumberWidth;
}
